import React from 'react';
import { Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import ConfigFieldControl from './components/ConfigFieldControl';
import { useFormContext } from '../FormContext';
import FormConfigTitleDescription from './FormConfigTitleDescription';
import FormConfigRequired from './FormConfigRequired';
export const FormConfigHtml = () => {
    var _a, _b, _c;
    const { formState, setFormState, notifyFormEdit } = useFormContext();
    const element = formState.selectedFormElement;
    if (!element.config)
        element.config = {};
    const handleSetFormState = (element) => {
        setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
        notifyFormEdit();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(FormControlLabel, { label: 'Make Editable', control: React.createElement(Checkbox, { color: 'primary', checked: Boolean(element.config.editable), onChange: () => {
                        element.config.editable = !element.config.editable;
                        if (element.config.editable) {
                            // remove current configured html value when set to editable
                            element.config.html && delete element.config.html;
                            // set default title and key value
                            element.title = 'Question';
                            element.key = 'question';
                        }
                        else {
                            // clear configuration when set to read only usage
                            element.config = {};
                            element.title = '';
                            element.key = '';
                            element.required = false;
                            element.description && delete element.description;
                            element.dataSource && delete element.dataSource;
                        }
                        handleSetFormState(element);
                    } }) })),
        element.config.editable && (React.createElement(React.Fragment, null,
            React.createElement(FormConfigTitleDescription, null),
            React.createElement(FormConfigRequired, null),
            React.createElement(ConfigFieldControl, null,
                React.createElement(TextField, { fullWidth: true, variant: 'outlined', label: 'Helper Text', value: ((_a = element.config) === null || _a === void 0 ? void 0 : _a.helperText) || '', onChange: event => {
                        element.config.helperText = event.target.value;
                        handleSetFormState(element);
                    } })),
            React.createElement(ConfigFieldControl, null,
                React.createElement(TextField, { fullWidth: true, variant: 'outlined', label: 'Placeholder', value: ((_b = element.config) === null || _b === void 0 ? void 0 : _b.placeholder) || '', onChange: event => {
                        element.config.placeholder = event.target.value;
                        setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                        notifyFormEdit();
                    } })),
            React.createElement(ConfigFieldControl, null,
                React.createElement(TextField, { fullWidth: true, variant: 'outlined', label: 'Default Value', value: ((_c = element.config) === null || _c === void 0 ? void 0 : _c.defaultValue) || '', onChange: event => {
                        element.config.defaultValue = event.target.value;
                        setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                        notifyFormEdit();
                    } }))))));
};
export default FormConfigHtml;
//# sourceMappingURL=FormConfigHtml.js.map